export default class LogsService {
  constructor (clientAgent) {
    this._clientAgent = clientAgent
  }

  fetchActivityLog (idStranka) {
    return this._clientAgent.makeRequest('logs/info', { idStranka })
  }

  fetchLoginHistory () {
    return this._clientAgent.makeRequest('logs/loginHistory', {})
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/Logs/LogsService.js